import Box from '@mui/material/Box';
import Icon from '@mdi/react';
import { mdiArrowLeftThin } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import { BaseBreadcrumbs, BaseLink } from '@mgm/common/components/base';
import { NavLink } from 'react-router-dom';
import { BulkShiftsTable } from './BulkShiftsTable';
import { ROUTES } from '../../../../../data';

const BulkShifts = () => {
  const { t } = useTranslation(['schedule', 'nav']);

  return (
    <Box>
      <BaseBreadcrumbs
        heading={t('bulkShifts')}
        links={[
          { name: t('schedules', { ns: 'nav' }), href: ROUTES.WORK_SCHEDULES },
          { name: t('bulkShifts'), href: ROUTES.SCHEDULES_BULK },
        ]}
        action={(
          <BaseLink NavLinkComponent={NavLink} to="/schedules">
            <Box mb={4} paddingTop={2} display="flex" justifyContent="start">
              <Icon className="mr-1" path={mdiArrowLeftThin} size={0.7} />
              {t('backToSchedule')}
            </Box>
          </BaseLink>
        )}
      />
      <BulkShiftsTable />
    </Box>
  );
};

export {
  BulkShifts,
};
